// Маскот персонажа: бирюзовый кругляш в повязке с гантелью. Анимации — классы mascot-* в index.css
// (покачивание, моргание, подъём гантели, прыжок); при prefers-reduced-motion он стоит спокойно.

import { cn } from '@/lib/cn'

export type MascotMood = 'idle' | 'cheer' | 'sleepy' | 'energetic' | 'sad'

export function MascotFigure({ mood = 'idle', level = 1, className }: {
  mood?: MascotMood
  level?: number
  className?: string
}) {
  const upbeat = mood === 'cheer' || mood === 'energetic'
  const band = level >= 20 ? '#e8b851' : level >= 10 ? '#a98af0' : level >= 5 ? '#619de8' : 'var(--muscle-primary)'
  return (
    <svg viewBox="-4 -6 72 74" aria-hidden className={cn('mascot overflow-visible', upbeat && 'mascot-cheer', className)}>
      <ellipse className="mascot-shadow" cx={32} cy={62} rx={15} ry={2.6} fill="#000" opacity={0.22} />
      <g className="mascot-body">
        {level >= 20 ? (
          <path d="M18 27 Q32 20 47 27 L60 62 Q45 58 32 65 Q19 58 4 62 Z" fill="#8958b8" />
        ) : null}
        {/* левая рука */}
        <path d="M11.5 39 Q2.5 42 4.5 51" fill="none" stroke="var(--accent-strong)" strokeWidth={4.5} strokeLinecap="round" />
        {/* тело и живот */}
        <path d="M32 8 C47 8 55 20 55 34 C55 49 45 57 32 57 C19 57 9 49 9 34 C9 20 17 8 32 8 Z" fill="var(--accent)" />
        <ellipse cx={32} cy={42} rx={13.5} ry={11} fill="#fff" opacity={0.2} />
        {/* повязка с узлом */}
        <path d="M11 22 Q32 13 53 22 L54.5 28 Q32 19.5 9.5 28 Z" fill={band} />
        <path d="M53 23 L61 19 L59.5 25 Z M53.5 26 L60 30 L56 31.5 Z" fill={band} />
        {/* глаза, блики, щёки, улыбка */}
        {mood === 'sleepy' ? (
          <path d="M21.5 33.5 Q25 37 28.5 33.5 M35.5 33.5 Q39 37 42.5 33.5" fill="none" stroke="#141716" strokeWidth={2} strokeLinecap="round" />
        ) : (
          <g className="mascot-eyes">
            <ellipse cx={25} cy={33} rx={3.3} ry={4.2} fill="#141716" />
            <ellipse cx={39} cy={33} rx={3.3} ry={4.2} fill="#141716" />
            <circle cx={26.2} cy={31.3} r={1.1} fill="#fff" />
            <circle cx={40.2} cy={31.3} r={1.1} fill="#fff" />
          </g>
        )}
        <path className="mascot-happy" d="M21.5 33.5 Q25 29.5 28.5 33.5 M35.5 33.5 Q39 29.5 42.5 33.5" fill="none" stroke="#141716" strokeWidth={2} strokeLinecap="round" />
        <ellipse cx={19.5} cy={39.5} rx={2.8} ry={1.6} fill="var(--muscle-primary)" opacity={0.45} />
        <ellipse cx={44.5} cy={39.5} rx={2.8} ry={1.6} fill="var(--muscle-primary)" opacity={0.45} />
        {mood === 'sleepy' ? <ellipse cx={32} cy={42} rx={2} ry={2.5} fill="#141716" /> : (
          <path d={mood === 'sad' ? 'M28 43 Q32 39 36 43' : 'M28 40.5 Q32 44.5 36 40.5'} fill="none" stroke="#141716" strokeWidth={1.9} strokeLinecap="round" />
        )}
        {/* правая рука с гантелью — поднимается */}
        <g className="mascot-curl">
          <path d="M51 38 Q58 37 59 29" fill="none" stroke="var(--accent-strong)" strokeWidth={4.5} strokeLinecap="round" />
          {level >= 10 ? (
            <>
              <rect x={55} y={23} width={8} height={7} rx={3} fill="none" stroke="#9aa19c" strokeWidth={2} />
              <circle cx={59} cy={34} r={5} fill="#5c625f" />
            </>
          ) : (
            <>
              <rect x={53} y={25.8} width={12} height={2.6} rx={1.3} fill="#9aa19c" />
              <rect x={52} y={22.5} width={3.6} height={9.2} rx={1.2} fill="#5c625f" />
              <rect x={62.4} y={22.5} width={3.6} height={9.2} rx={1.2} fill="#5c625f" />
            </>
          )}
        </g>
      </g>
    </svg>
  )
}
